import { Component, OnInit } from "@angular/core";

import { ProductService } from "src/app/shared/services/product.service";
import { take, first } from "rxjs/operators";
import * as _ from "lodash";
import {
  ScrollToService,
  ScrollToConfigOptions,
} from "@nicky-lenaers/ngx-scroll-to";
import { MatDialog } from "@angular/material";
import { CartService } from "src/app/shared/services/cart-service";
import { ProductOrderModalComponent } from "./product-order-modal/product-order-modal.component";
import { Product } from "src/app/shared/models/product";
import { SpinnerService } from "src/app/shared/services/spinner.service";
import { Order } from "src/app/shared/models/order";
import { OrderService } from "src/app/shared/services/order-service";
import { ActivatedRoute } from "@angular/router";
import { DbUtils } from "functions/src/utils/db-utils";
import { Dbutils } from "src/app/shared/services/db-utils";

@Component({
  selector: "app-product-list",
  templateUrl: "./product-list.component.html",
  styleUrls: ["./product-list.component.scss"],
})
export class ProductListComponent implements OnInit {
  public productCategories: any[] = [];
  public products: any[] = [];
  public visibleCategory: any;
  public order: Order;
  constructor(
    private dialog: MatDialog,
    private productService: ProductService,
    private cartService: CartService,
    private scrollToService: ScrollToService,
    private spinnerService: SpinnerService,
    private orderService: OrderService,
    private route: ActivatedRoute,
    private dbutils:Dbutils
  ) { }

  ngOnInit() {
    this.spinnerService.show();
    setTimeout(spinner => { this.spinnerService.hide() }, 1000)
    this.productService
      .getProducts()
      .valueChanges()
      .pipe(take(1))
      .subscribe((products) => {
        this.products = _.filter(products, (product => (product.productActive)))
      });
    this.productService
      .getCategories()
      .valueChanges()
      .pipe(take(1))
      .subscribe((categories) => {
        this.productCategories = _.filter(categories, (cat => (cat.active)))
        this.productCategories = _.orderBy(
          this.productCategories,
          "categoryId",
          "asc"
        );
        this.visibleCategory = categories[0]["categoryName"];
      });
    this.orderService
      .getOrder()
      //   .pipe(takeUntil())
      .subscribe((order: Order) => {
        this.order = order;
      });
    this.route.queryParams.subscribe(params => {
      const table = params['table'];
      const branch = params['branch'];
      console.log("table", table);
      console.log("branch", branch);
      if (table > 0) {
        this.orderService.setOrder({ remarks: `מספר שולחן :   ${table} `, orderType: "TA" ,branch:branch})
      }
    });

  }

  public eventFromChild(event: any) {
    this.visibleCategory = event.categoryName;
    // console.log("eventFromChild", event);
    this.scrollTo(event.categoryName);
  }

  public inViewport(isInViewport: boolean, category: any): void {
    // console.log("inview", isInViewport, category);
    if (isInViewport) {
      this.visibleCategory = category.categoryName;
    }
  }

  public scrollTo(cat: string) {
    const o: ScrollToConfigOptions = { target: `#${cat}`, offset: -130 };
    this.scrollToService.scrollTo(o);
  }

  public async openProductModal(product: Product){
    this.spinnerService.show();
    const productObject:Product=_.cloneDeep(product);
    console.log("productObject",productObject);
    const newP =await this.getToppingsGroup(productObject)
    console.log("newP",newP);
    const menuMode = this.order.orderType ? false : true;
    const dialogRef = this.dialog.open(ProductOrderModalComponent, {
      width: "auto",
      height: "auto",
      maxWidth: "none",
      minWidth: "0px",
      autoFocus: false,
      data: { product:productObject, menuMode: menuMode },
    });
    dialogRef
      .afterClosed()
      .pipe(first())
      .subscribe((result) => {
        if (!_.isNil(result)) {
          this.cartService.addToCart(result);
        }
      });
  }
  
  public async getToppingsGroup(product: Product):Promise<Product>{
    let toppingsGroups=[];
    for (var toppingGroup in product.toppings) {
      let group=await this.dbutils.getoppingGroup(product.toppings[toppingGroup]["key"]);
      group.toppings=_.filter(group.toppings,(topping)=>(topping.productActive));
      toppingsGroups.push(group);
    }
    product.toppings=toppingsGroups
    return product;
  }

}
